import { PropsWithChildren } from "react";
import classes from "./Centered.module.css";

type CenteredProps = PropsWithChildren<{}>;

export default function Centered(props: CenteredProps) {
  return <div className={classes.container}>{props.children}</div>;
}
